import type { FC } from 'react';

import { SvgIcon, type SvgIconProps } from '../SvgIcon';

export const VideoFormatSocialMediaIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="0 0 32 32" {...props}>
    <path
      d="M26 24L26 8C26 7.20435 25.6839 6.44129 25.1213 5.87868C24.5587 5.31607 23.7956 5 23 5L9 5C8.20435 5 7.44129 5.31607 6.87868 5.87868C6.31607 6.44129 6 7.20435 6 8L6 24C6 24.7956 6.31607 25.5587 6.87868 26.1213C7.44129 26.6839 8.20435 27 9 27L23 27C23.7956 27 24.5587 26.6839 25.1213 26.1213C25.6839 25.5587 26 24.7956 26 24ZM9 25C8.73478 25 8.48043 24.8946 8.29289 24.7071C8.10536 24.5196 8 24.2652 8 24L8 8C8 7.73478 8.10536 7.48043 8.29289 7.29289C8.48043 7.10536 8.73478 7 9 7L23 7C23.2652 7 23.5196 7.10536 23.7071 7.29289C23.8946 7.48043 24 7.73478 24 8L24 24C24 24.2652 23.8946 24.5196 23.7071 24.7071C23.5196 24.8946 23.2652 25 23 25L9 25Z"
      fill="currentColor"
    />
  </SvgIcon>
);
